
import {urls} from "../../constants";
import { axiosService } from "../axios.service";


const productGroupService = {
    getAll: () => axiosService.get(urls.settings.productGroups).then(value => value.data),
    createGroup: (data) => axiosService.post(urls.settings.productGroups, data).then((value) => value.data),
    updateById: (id, data) => axiosService.patch(`${urls.settings.productGroups }/${id}`, data).then((value) => value.data),
    deleteById: (id) => axiosService.destroy(`${urls.settings.productGroups}/${id}`),
};

export {
    productGroupService
}